import { energyApi } from "utilities/Axios";

export const getAllTagTypes = () => {
  return energyApi.get("/TagType/GetAllTagTypes");
};

export const createTagType = (tagType: any) => {
  return energyApi.post("/TagType/CreateTagType", tagType);
};

export const updateTagType = (tagType: any) => {
  return energyApi.post("/TagType/UpdateTagType", tagType);
};

export const deleteTagType = (id: any) => {
  return energyApi.post(`/TagType/DeleteTagType?id=${id}`);
};

export const deleteTagTypes = (ids: any) => {
  return energyApi.post(`/TagType/DeleteTagTypes`, ids);
};
